var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L12 0L12 12L0 12L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "man-user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L12 0L12 12L0 12L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.4364048 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.56359 5.86879C5.89779 5.86879 6.97947 4.55503 6.97947 2.93441C6.97947 1.31376 6.62434 0 4.56359 0C2.50285 0 2.14765 1.31376 2.14765 2.93441C2.14765 4.55503 3.22933 5.86879 4.56359 5.86879L4.56359 5.86879Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.1 10.3985C0.0134049 10.2039 -0.0731902 10.3436 0.1 10.3985L0.1 10.3985L0.1 10.3985Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12651 10.4367C9.31486 10.4065 9.19096 10.2276 9.12651 10.4367L9.12651 10.4367L9.12651 10.4367Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12137 10.2308C9.07662 7.4076 8.70792 6.60315 5.88644 6.09394C5.88644 6.09394 5.48928 6.60003 4.56356 6.60003C3.63785 6.60003 3.24061 6.09394 3.24061 6.09394C0.449927 6.5976 0.0587954 7.39011 0.00736686 10.139C0.00314968 10.3635 0.00119542 10.3753 0.000441153 10.3492C0.000612619 10.3981 0.000818351 10.4884 0.000818351 10.6459C0.000818351 10.6459 0.672544 12 4.56356 12C8.45451 12 9.1263 10.6459 9.1263 10.6459C9.1263 10.5447 9.12637 10.4743 9.12648 10.4265C9.12572 10.4426 9.12421 10.4113 9.12137 10.2308L9.12137 10.2308Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManUser);
export default __webpack_public_path__ + "static/media/man-user.a36923f05650058b2eb47a7ab00df040.svg";
export { ForwardRef as ReactComponent };